// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { PartConfigCrossArm } from './part-config-cross-arm';
import { PartConfigPlaceQuantity } from './part-config-place-quantity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PartConfigPlaceQuantityCrossArmLink extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  deleted?: Date;
  displayOrder?: number;
  isDefault!: boolean;
  partConfigCrossArmId!: number;
  partConfigPlaceQuantityId!: number;
  partConfigCrossArm!: PartConfigCrossArm;
  partConfigPlaceQuantity!: PartConfigPlaceQuantity;
}

